import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'a', 'b', 'blockquote', 'br', 'caption', 'code', 'col', 'colgroup', 'div', 'em', 'font',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img', 'li', 'ol', 'p', 'pre', 's', 'span',
  'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul',
];

const ALLOWED_ATTR = [
  'align', 'alt', 'color', 'colspan', 'height', 'href', 'rel', 'rowspan', 'size', 'src', 'style',
  'target', 'title', 'width',
];

const ALLOWED_STYLES = [
  'background-color', 'border', 'border-collapse', 'color', 'font-size', 'font-style', 'font-weight',
  'height', 'margin-left', 'margin-right', 'padding-left', 'padding-right', 'text-align',
  'text-decoration', 'vertical-align', 'width',
];

const keepAllowedStyles = (node) => {
  const declarations = ALLOWED_STYLES
    .map((property) => [property, node.style.getPropertyValue(property)])
    .filter(([, value]) => value)
    .map(([property, value]) => `${property}: ${value};`);

  if (declarations.length > 0) {
    node.setAttribute('style', declarations.join(' '));
  } else {
    node.removeAttribute('style');
  }
};

const isolateLinkTarget = (node) => {
  const rel = (node.getAttribute('rel') || '')
    .split(/\s+/)
    .filter((token) => token && token !== 'opener' && token !== 'noopener');
  node.setAttribute('rel', [...rel, 'noopener'].join(' '));
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.hasAttribute?.('style')) {
    keepAllowedStyles(node);
  }
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    isolateLinkTarget(node);
  }
});

export const sanitizeHtml = (html) => DOMPurify.sanitize(html, {
  ALLOWED_TAGS,
  ALLOWED_ATTR,
  ALLOW_ARIA_ATTR: false,
  ALLOW_DATA_ATTR: false,
});
